import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import classNames from 'classnames';
import { Icons } from '../base/BootstrapComponents/BootstrapComponents';
import {
  smevCheckFormatter, localeFormatter, applicationStatusOperation,
} from '../../utils/formatters';
import { CHECK_STATUS_LIST } from '../../configs';

export default function MobileLayoutLegend({ onHide = () => {} }) {
  const location = useLocation();
  const isApplication = location.pathname.includes('application');
  const isRegistry = location.pathname.includes('region-registry');
  return (
    <div className={classNames('helper-tooltip', { extension: isApplication || isRegistry })}>
      <div className="pmh-block">
        <div className="pmh-title">
          Легенда
          <div className="pmh-title-close" onClick={onHide}>
            <Icons icon="close" customIcon />
          </div>
        </div>
        <div className="pmh-table">
          <div className="pmh-column">
            <div className="pmh-column-title">Значение иконок</div>
            <div className="pmh-data-row">
              <div className="legend-icon-block">
                <div className="legend-icon">
                  <Icons icon="update-period-30" customIcon />
                </div>
                Обновление данных
              </div>
            </div>
            <div className="pmh-data-row">
              <div className="legend-icon-block">
                <div className="legend-icon">
                  <Icons icon="glasses" customIcon />
                </div>
                Версия для слабовидящих
              </div>
            </div>
            {/* <div className="pmh-data-row"> */}
            {/*  <div className="legend-icon-block"> */}
            {/*    <div className="legend-icon"> */}
            {/*      <Icons icon="filter" customIcon /> */}
            {/*    </div> */}
            {/*    Фильтр */}
            {/*  </div> */}
            {/* </div> */}
            <div className="pmh-data-row">
              <div className="legend-icon-block">
                <div className="legend-icon">
                  <Icons icon="plus" customIcon />
                </div>
                Создать запись
              </div>
            </div>
            <div className="pmh-data-row">
              <div className="legend-icon-block">
                <div className="legend-icon">
                  <Icons icon="gear" customIcon />
                </div>
                Настроить колонки в таблице
              </div>
            </div>
          </div>
          {isApplication || isRegistry ? (
            <div className="pmh-column">
              <div className="pmh-column-title">Статусы проверок</div>
              {CHECK_STATUS_LIST.map((i, key) => (
                <div key={key} className="pmh-data-row">
                  {smevCheckFormatter(i, {
                    type: { name: localeFormatter('check.status', i.value) },
                    status: i.value,
                  })}
                </div>
              ))}
            </div>
          ) : null }
          {isApplication ? (
            <div className="pmh-column">
              <div className="pmh-column-title">Статусы обращений</div>
              <div className="pmh-data-row">
                {applicationStatusOperation(0, 'Дата направления уведомления о приостановке')}
                {applicationStatusOperation(1, 'До даты закрытия обращения 2 дня')}
                {applicationStatusOperation(2, 'До даты закрытия обращения 1 день ')}
                {applicationStatusOperation(3, 'День закрытия обращения/обращение просрочено')}
                {applicationStatusOperation(4, 'Архивная запись')}
              </div>
            </div>
          ) : null}
          {isRegistry ? (
            <div className="pmh-column">
              <div className="pmh-column-title">Статусы реестров</div>
              <div className="pmh-data-row">
                {applicationStatusOperation(3, 'Срок действия записи истёк/запись аннулирована')}
                {applicationStatusOperation(4, 'Архивная запись')}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
